// Main Scripts
// ---------------------
import ticketButton from './js/widgets/ticketButton.js';

import mainSlideshowConcept2 from './js/widgets/mainSlideshowConcept2.js';
import multiScheduleFeatureConcept2 from './js/widgets/multiScheduleFeatureConcept2.js';

import seoCards from './js/widgets/seoCards.js';
import seoWidget from './js/widgets/seoWidget.js';

import videoWidget from './js/widgets/videoWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Secondary Scripts
// ---------------------
import './js/localjs.js';

$(document).ready(function () {
  ticketButton();

  if (window.location.pathname === '/') {
    mainSlideshowConcept2();
    multiScheduleFeatureConcept2();
    seoCards();
    seoWidget();
    scrollerSponsors();

    $(window).load(function () {
      videoWidget();
    });
  }
});
